import styled from '@emotion/styled/macro'

import { pageContentDefaultSize } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'

const QuestionnaireIntroductionPage = styled('section')`
  ${pageContentDefaultSize}

  color: var(--CINight);
  margin-top: 48px;

  > h2 {
    margin-bottom: 16px;
    color: #374b50;
  }

  ${mediaQuery('tablet')} {
    margin-top: 24px;
  }
`

const QuestionnaireIntroductionContainer = styled('div')`
  margin-top: 16px;
  font-size: 14px;
  font-weight: 400;
  color: var(--print-secondary);
  white-space: pre-line;

  margin-bottom: 32px;

  .mdi-information-outline:before {
    margin-right: 10px;
    font-size: 16px !important;
  }
`

export { QuestionnaireIntroductionPage, QuestionnaireIntroductionContainer }
